// With the `.ts` extension: `scripts/trim-catalogs.ts` imports this under plain
// Node, which resolves no other way.
import { SupportedLanguagesSchema } from "./api/generated/schemas.gen.ts";

/**
 * Every language the API supports, one record each: ISO codes, English and
 * native name, text direction and target regions (the first is the default
 * variant). Generated from the schema's `x-seerlinq-languages`, so a language
 * the API adds arrives with the next `pnpm api:update`.
 */
export const languages = SupportedLanguagesSchema["x-seerlinq-languages"];

/** The language of a locale tag: `ar-SA` → `ar`, `zh-Hans-CN` → `zh-Hans`. */
export function languageOf(tag: string): string {
  return tag.replace(/-[A-Z]{2}$/, "");
}

export function localeDir(tag: string): "ltr" | "rtl" {
  return findLanguage(tag)?.dir ?? "ltr";
}

/**
 * A locale's name as pickers and tables show it: native name first, English
 * second ("Deutsch, German"), plus the country for a variant ("العربية,
 * Arabic (Saudi Arabia)"). Not translated, so it reads the same in every UI
 * language.
 */
export function localeLabel(tag: string): string {
  const language = findLanguage(tag);
  if (!language) return tag;

  const name =
    language.native_name === language.name
      ? language.name
      : `${language.native_name}, ${language.name}`;
  const region = tag.slice(language.code.length + 1);
  return region ? `${name} (${regionNames.of(region)})` : name;
}

function findLanguage(tag: string) {
  const code = languageOf(tag);
  return languages.find((language) => language.code === code);
}

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
